import type { UsePermissionsReturn } from '@/contexts/AuthContext/usePermissions';

export type BillingAccessViewState =
    | 'loading'
    | 'ready'
    | 'permission-denied'
    | 'error';

interface ResolveBillingAccessViewStateInput {
    workspaceId?: string | null;
    isLoadingProfile: boolean;
    isLoadingWorkspaces: boolean;
    permissionStatus: UsePermissionsReturn['status'];
    canView: boolean;
}

export const resolveBillingAccessViewState = ({
    workspaceId,
    isLoadingProfile,
    isLoadingWorkspaces,
    permissionStatus,
    canView,
}: ResolveBillingAccessViewStateInput): BillingAccessViewState => {
    if (isLoadingProfile || isLoadingWorkspaces || !workspaceId) {
        return 'loading';
    }

    if (permissionStatus === 'idle' || permissionStatus === 'loading') {
        return 'loading';
    }

    if (permissionStatus === 'error') {
        return 'error';
    }

    return canView ? 'ready' : 'permission-denied';
};
